import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import AnalyzerSelectLocal from '../analyzers/AnalyzerSelectLocal';
import SnapshotSelectLocal from '../snapshots/SnapshotSelectLocal';

import { Grid, TextField } from '@mui/material';

import { Control, Controller, UseFormWatch } from 'react-hook-form';

import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';
import { useSnapshots } from 'features/snapshots/api/getSnapshots';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';

interface Props {
  control: Control<any>;
  watch: UseFormWatch<any>;
}

const TraceHistoryFilter = ({ control, watch }: Props) => {
  const { data: analyzers } = useAnalyzers({});
  const { data: snapshots } = useSnapshots({ analyzerId: watch('analyzerId') });
  const { dateFormatWithZeros, timeFormat, ampm } = useUserDateTime();

  return (
    <>
      <Grid item xs={2} style={{ minWidth: '15rem' }}>
        <Controller
          name='fromDate'
          control={control}
          rules={{
            required: true,
            validate: (value) =>
              value < watch('toDate') || 'From date must be before to date.',
          }}
          render={({ field: { onChange, value } }) => (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                label='From'
                inputFormat={`${dateFormatWithZeros} ${timeFormat}`}
                value={value}
                onChange={onChange}
                renderInput={(props) => <TextField {...props} />}
                ampm={ampm}
              />
            </LocalizationProvider>
          )}
        />
      </Grid>
      <Grid item xs={2} style={{ minWidth: '15rem' }}>
        <Controller
          name='toDate'
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value } }) => (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                label='To'
                inputFormat={`${dateFormatWithZeros} ${timeFormat}`}
                value={value}
                onChange={onChange}
                renderInput={(props) => <TextField {...props} />}
                ampm={ampm}
              />
            </LocalizationProvider>
          )}
        />
      </Grid>
      <Grid item xs={2} style={{ minWidth: '8rem' }}>
        <Controller
          name='analyzerId'
          control={control}
          rules={{
            required: 'An analyzer must be selected.',
            validate: (value) =>
              Number(value) !== -1 || 'An analyzer must be selected.',
          }}
          render={({ field: { onChange, value } }) => (
            <AnalyzerSelectLocal
              analyzers={analyzers}
              selectedAnalyzerId={value}
              handleAnalyzerChanged={onChange}
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid item xs={2} style={{ minWidth: '8rem' }}>
        <Controller
          name='snapshotId'
          control={control}
          rules={{
            required: 'A snapshot must be selected.',
            validate: (value) =>
              Number(value) !== -1 || 'A snapshot must be selected.',
          }}
          render={({ field: { onChange, value } }) => (
            <SnapshotSelectLocal
              snapshots={snapshots}
              selectedSnapshotId={value}
              handleSnapshotChanged={onChange}
              fullWidth
            />
          )}
        />
      </Grid>
    </>
  );
};

export default TraceHistoryFilter;
